import { render } from "./Dashboard.vue?vue&type=template&id=a2c70a22&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=a2c70a22&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a2c70a22"

export default script